import { __decorate, __metadata } from "tslib";
import { MEDIA_PROPS_ACCESSOR, MEDIA_PROPS_EDITORDEF, MediaAssets } from '@common/media/shared';
import { UserRole } from '@core/shared/access';
import { AllowHtml, CrudEndpoints, Default, EditorDefinition, Expose, IdItemModel, IsBoolean, ItemModelDefinition, ItemModelProp, ModelId, Structure, Trim, ValidateNested } from '@core/shared/model';
import { UseRestraints } from '@core/shared/restraints';
import { QuestionAttachmentItem } from './question-attachment.item';
import { QuestionCategoryRestraints } from './question-category.restraints';
import { QuestionItem } from './question.item';
let QuestionCategoryItem = /*#__PURE__*/(() => {
  let QuestionCategoryItem = class QuestionCategoryItem extends IdItemModel {
    // OwnerId | optional, expose when needed 
    // Certain items may be owned by a user. Based on restraints, some privileges may be granted only to the owner.
    // @Expose()
    // @Default(null)
    // ownerId:number;
    toString() {
      return "Question Category " + this.name;
    }
  };
  __decorate([Expose(), Default(true), __metadata("design:type", Boolean)], QuestionCategoryItem.prototype, "enabled", void 0);
  __decorate([IsBoolean(), Expose(), ItemModelProp({
    defaultValueCreate: false
  }), __metadata("design:type", Boolean)], QuestionCategoryItem.prototype, "teaser", void 0);
  __decorate([IsBoolean(), Expose(), ItemModelProp({
    defaultValueCreate: false
  }), __metadata("design:type", Boolean)], QuestionCategoryItem.prototype, "highlight", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: [UserRole.REGISTERED]
  }), __metadata("design:type", Array)], QuestionCategoryItem.prototype, "access", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], QuestionCategoryItem.prototype, "hasAccess", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), __metadata("design:type", String)], QuestionCategoryItem.prototype, "name", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: 999
  }), __metadata("design:type", Number)], QuestionCategoryItem.prototype, "ordering", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), AllowHtml(), __metadata("design:type", String)], QuestionCategoryItem.prototype, "description", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), AllowHtml(), __metadata("design:type", String)], QuestionCategoryItem.prototype, "detailDescription", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", Number)], QuestionCategoryItem.prototype, "duration", void 0);
  __decorate([Expose(), Structure(Array, () => QuestionItem)
  // @Default([]) // Should not have default value?! this would reset items when saving without loading relation before??
  , __metadata("design:type", Array)], QuestionCategoryItem.prototype, "items", void 0);
  __decorate([Expose(), Structure(Array, () => QuestionAttachmentItem), ValidateNested(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", Array)], QuestionCategoryItem.prototype, "attachments", void 0);
  QuestionCategoryItem = __decorate([EditorDefinition('admin-general', {
    'name': true,
    'enabled': true,
    'teaser': true,
    'highlight': true,
    'access': true,
    'thumbnail': true,
    'description': true,
    'detailDescription': true,
    [MEDIA_PROPS_ACCESSOR]: MEDIA_PROPS_EDITORDEF
    // attachments:{loadDefinition:'admin-attachments'},
  }, {
    useCrudEndpoint: 'admin'
  }), EditorDefinition('admin-attachments', {
    attachments: {
      loadDefinition: 'admin-attachments'
    }
  }, {
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/questions/categories',
    public: '/questions/categories'
  }), UseRestraints(QuestionCategoryRestraints), ItemModelDefinition({
    texts: {
      item: 'Thema',
      items: 'Themen',
      newItem: 'Neues Thema erstellen'
    }
  }), MediaAssets(['thumbnail']), ModelId("QuestionCategoryItem") // auto-generated by generate-model-ids
  ], QuestionCategoryItem);
  return QuestionCategoryItem;
})();
export { QuestionCategoryItem };